import React from "react";
import { List } from "devextreme-react";
import styles from "./ListTemplate.module.css";
import classNames from "classnames";
function ListTemplate({ classNameContainer, classNameContainerList, classNameList, header, ...props }) {
    return (React.createElement("div", { className: classNames(styles.container, classNameContainer) }, header === null || header === void 0 ? void 0 :
        header(),
        React.createElement("div", { className: classNames(styles.list, classNameContainerList) },
            React.createElement(List, { className: classNameList, ...props }))));
}
export default ListTemplate;
